'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgMission(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M0 8.965a.53.53 0 00.53.535h10.93a.536.536 0 100-1.071H.54a.54.54 0 00-.54.536zm11.46 1.607a.536.536 0 110 1.071H.526A.53.53 0 010 11.108a.54.54 0 01.54-.536zM10.289.5c.947 0 1.714.768 1.714 1.714v3.43c0 .946-.767 1.713-1.714 1.713H1.717A1.714 1.714 0 01.003 5.643V2.214C.003 1.268.77.5 1.717.5h8.572zm-.186 1.071H1.888c-.454 0-.822.352-.822.786V5.5c0 .434.368.786.822.786h8.215c.453 0 .821-.352.821-.786V2.357c0-.434-.368-.786-.821-.786z", id: "Mission__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Mission__svg__a" })))));
}

module.exports = SvgMission;
//# sourceMappingURL=Mission.js.map
